import '../sass/races.scss';

(() => {
    const $blocks = document.querySelectorAll('.races');

    $blocks?.forEach($block => {
        const $yearForm = $block.querySelector('.races__year-form');
        const $yearSelect = $block.querySelector('.races__year-select');

        const initYearSelect = () => {
            if (!$yearSelect || !$yearForm) return;

            $yearSelect.addEventListener('change', () => {
                $yearForm.submit();
            });
        };

        initYearSelect();
    });
})();
